import { numberToCurrency } from '@hc-frontend/utils'
import sendEmailFromAgent from 'core/services/email/sendEmailFromAgent'
import makeBase from 'core/services/email/sendEmailFromAgent/makeBase'
import getURLProfile from 'utils/pivot/member/getURLProfile'
import { COMPARE_PLANS, DETAILS } from 'sites/routes'
import isEpicPlan from 'utils/pivot/plan/isEpicPlan'
import isRXPlan from 'utils/pivot/plan/isRXPlan'
import { capitalize } from '@hc-frontend/utils'
import store from 'utils/store/withMiddleware'
import config from './config'
import { sendEmailQuoteEvent } from 'core/services/email/blueshift/implementations/email-quote'
import getExtendedTagMessage from 'utils/pivot/plan/getExtendedTagMessage'
import getExtendDuration from 'utils/pivot/plan/getExtendDuration'
import getMaxPolicies from 'utils/pivot/plan/getMaxPolicies'

const asMoneyWithoutDecimal = value => numberToCurrency(+value)
const getProperty = (plans, property) => plans.map(plan => plan[property])
const getCoreProperty = (plans, property, cb) =>
  plans.map(plan => cb(plan.coreBenefits[property]))

const getPlansDurations = plans => {
  return plans.map(plan => {
    const extendedDuration = getExtendDuration(plan, plan.period)

    const { policies } = getMaxPolicies(plan, plan.period)
    return `${getExtendedTagMessage({
      period: +plan.period,
      currentPolicy: +plan.policies,
      maxPolicies: policies,
      extendedDuration
    })} days`
  })
}

const getPlanName = plans =>
  plans.map(plan => `${plan.planName}${isRXPlan(plan) ? ' | Rx' : ''}`)

function makePayload({ valuesForm, agentInformation, plans, salesCenterAgent }) {
  const data = makeBase({ valuesForm, agentInformation, salesCenterAgent })
  const state = store.getState()

  const urlProfile =
    getURLProfile({
      addPlanId: false,
      placement: config.placement
    }) + `&uid=${state.hcStorage.healthcareUserId}`

  data.template_name = 'plan-comparison'
  data.message.global_merge_vars = data.message.global_merge_vars.concat([
    {
      name: 'attributes',
      content: [
        {
          className: 'even',
          items: ['Plan Name', ...getPlanName(plans)]
        },
        {
          className: 'odd',
          items: ['Coverage Duration', ...getPlansDurations(plans)]
        },
        {
          className: 'even',
          items: [
            'Deductible',
            ...getCoreProperty(plans, 'deductible', asMoneyWithoutDecimal)
          ]
        },
        {
          className: 'odd',
          items: [
            'Coinsurance',
            ...getCoreProperty(plans, 'userCoinsurance', val => `${val}%`)
          ]
        },
        {
          className: 'even',
          items: [
            'Max Out of Pocket',
            ...getCoreProperty(plans, 'outOfPocketMax', asMoneyWithoutDecimal)
          ]
        },
        {
          className: 'odd',
          items: [
            'Lifetime Max',
            ...getCoreProperty(plans, 'lifetimeMax', asMoneyWithoutDecimal)
          ]
        },
        {
          className: 'even',
          items: ['Network Type', ...getCoreProperty(plans, 'network', capitalize)]
        },
        {
          className: 'odd',
          items: [
            'Network Provider',
            ...getCoreProperty(plans, 'networkProvider', capitalize)
          ]
        },
        {
          className: 'even',
          items: ['Monthly Premium*', ...getProperty(plans, 'monthlyPremium')]
        }
      ]
    },
    {
      name: 'linkToQuote',
      content: `https://${
        window.location.hostname
      }${COMPARE_PLANS}?${urlProfile}&plans=${plans
        .map(plan => `${plan.planId}-${plan.period}-${plan.policies}`)
        .join(',')}`
    },
    {
      name: 'idOptions',
      content: plans.map((_, index) => '' + (index + 1))
    },
    {
      name: 'linksBrochure',
      content: plans.map(plan => plan.brochure)
    },
    {
      name: 'linksView',
      content: plans.map(
        plan =>
          `https://${window.location.hostname}${DETAILS}?${urlProfile}&planid=${plan.planId}&period=${plan.period}`
      )
    },
    {
      name: 'hasEpic',
      content: plans.some(isEpicPlan)
    },
    {
      name: 'hasCompanion',
      content: plans.some(plan => !isEpicPlan(plan))
    }
  ])

  return data
}

function comparePlansFromAgent(salesCenterAgent, valuesForm, agentInformation) {
  const state = store.getState()

  const data = makePayload({
    valuesForm,
    agentInformation,
    plans: state.plansToShow.map(id => state.plansData[id]),
    salesCenterAgent
  })

  const quote = data.message.global_merge_vars.find(
    item => item.name === 'linkToQuote'
  ).content

  sendEmailQuoteEvent(quote)

  sendEmailFromAgent({
    config,
    data
  })
}

export default comparePlansFromAgent
